import { Grid, Link } from "@mui/material";

export default function VendorFormThanksPage() {
    return (
        <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"100%"}
            textAlign={"center"}
        >
            <Grid item>
                <h2>
                    Thanks for registering as a vendor at MakeOS. Our producer
                    will reach out if further inforamtion is required.
                </h2>
            </Grid>
        </Grid>
    );
}
